import React, { useState } from "react";
import "../styles/waitlist.css";  // ✅ import the CSS
import { motion, useMotionValue, useTransform, useSpring } from "framer-motion";

export default function WaitlistForm() {
  const [formData, setFormData] = useState({ name: "", email: "", comment: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("https://formspree.io/f/mzzanlln", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", comment: "" });
      } else {
        setStatus("error");
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  // 3D Hover Parallax Effect
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const mouseXSpring = useSpring(x, { stiffness: 150, damping: 15 });
  const mouseYSpring = useSpring(y, { stiffness: 150, damping: 15 });
  const rotateX = useTransform(mouseYSpring, [-0.5, 0.5], ["7deg", "-7deg"]);
  const rotateY = useTransform(mouseXSpring, [-0.5, 0.5], ["-7deg", "7deg"]);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const xPct = mouseX / width - 0.5;
    const yPct = mouseY / height - 0.5;
    x.set(xPct);
    y.set(yPct);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <section id="waitlist" className="waitlist-section" style={{ perspective: 1200, display: "flex", justifyContent: "center", alignItems: "center", padding: "5rem 1rem" }}>
      <motion.div
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          rotateX,
          rotateY,
          transformStyle: "preserve-3d",
          background: "rgba(20, 20, 20, 0.6)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "24px",
          padding: "3rem",
          maxWidth: "600px",
          width: "100%",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(12px)",
        }}
      >
        <motion.h2 style={{ transform: "translateZ(50px)" }} className="waitlist-title">
          📰 Join the Newsletter
        </motion.h2>

        {status === "success" ? (
          <motion.p style={{ transform: "translateZ(30px)" }} className="waitlist-success">
              🎉 You're subscribed! We'll keep you posted.
          </motion.p>
        ) : (
          <motion.form style={{ transform: "translateZ(40px)" }} onSubmit={handleSubmit} className="waitlist-form">
            {/* Name */}
            <div>
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div>
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Message */}
            <div>
              <label>Message</label>
              <textarea
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                rows={4}
              ></textarea>
            </div>

            {/* Submit */}
            <button type="submit" disabled={status === "loading"}>
              {status === "loading" ? "Submitting..." : "✨ Subscribe"}
            </button>
          </motion.form>
        )}
      </motion.div>
    </section>
  );
}
